import { Col, Row } from "antd";
import { omit } from "lodash";
import React, { memo, useEffect, useState } from "react";
import { KEY_OPTIONS } from "../../common/constant";
// import { WIDTH_MOBILE } from "../../common/constant";
import BoughtTogetherProducts from "../../components/boughtTogetherProduct";
import ProductBanner from "../../components/productBanner";
import ProductInformation from "../../components/productInformation";
import ProductOverview from "../../components/productOverview";
import RelatedProducts from "../../components/relatedProduct";
import { products } from "../../services";
// import { getBanners } from "../../shared/helpers";
import { setTitlePage } from "../../utils/helper";
import * as GTM from "../../components/tracking/GTM";
import "./style.scss";

const Product = memo((props: any) => {
  const { location, match } = props;
  const querySearch = new URLSearchParams(location.search);
  const _productCode = location.state?.product_code || match.params.pro_code;
  const _productId = location.state?.product_id;
  const _productFoam =
    location.state?.product_foam || querySearch.get("foam") || "";
  const _productSpecCode =
    location.state?.product_spec_code || querySearch.get("spec") || "";
  const _path = match.params.pro_id;
  const [product, setProduct] = useState<any>(null);
  const [productCode, setProductCode] = useState(_productCode);

  // const { innerWidth } = window;
  const [banners, setBanners] = useState<any>([]);

  useEffect(() => {
    if (product) {
      setProduct(null);
    }

    const query = {
      product_id: _productId,
      product_code: _productCode,
      path: _path,
    };

    products.getProduct(query, (data, err) => {
      if (data) {
        data.slug = _path;
        setProduct(data);
        setTitlePage(data.name);
        window.scrollTo(0, 0);
      }
    });

    return () => {
      const storageOption = omit(
        JSON.parse(sessionStorage.getItem(KEY_OPTIONS) || "{}"),
        match.params.pro_id
      );

      sessionStorage.setItem(KEY_OPTIONS, JSON.stringify(storageOption));
    };
  }, [match.params.pro_id]);

  const [size, setSize] = useState([0, 0]);

  useEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    if (product) {
      trackingViewProduct();
    }
  }, [product]);

  const trackingViewProduct = () => {
    if (!product || !product.size_prices) {
      return;
    }

    const sizePrice = product.size_prices.find(
      (x: any) => x.value == product.code
    );
    if (!sizePrice) {
      return;
    }
    const price = sizePrice.price
      ? parseInt(sizePrice.price.replaceAll(".", ""))
      : 0;
    const unitPrice = sizePrice.price_promotion
      ? parseInt(sizePrice.price_promotion.replaceAll(".", ""))
      : 0;

    GTM.trackingViewDetailProduct({
      id: product.code,
      name: product.name,
      category: product.category_name,
      price: price,
      quantity: 1,
      variant: sizePrice?.label,
      discount_price: price - unitPrice,
      promotion: sizePrice?.info_promotion?.name,
      subtotal_amount: unitPrice * 1,
      unit_price: unitPrice,
    });
  };

  return (
    product && (
      <div className="kd-product-detail-container">
        <Row>
          <ProductBanner
            banners={banners}
            productName={product.name}
            imageDescription={product.image_description}
          />
        </Row>
        <Row justify="center" style={{ backgroundColor: "rgb(245, 245, 245)" }}>
          <Col className="kd-product-detail-wrap">
            <Row
              align="middle"
              justify="center"
              className="product-detail-name-wrapper">
              <span id="product-detail-name" className="main-title">
                {product.name}
              </span>
            </Row>
            {/* <Row
              align="middle"
              justify="center"
              className="product-detail-short-description-wrapper">
              <span className="main-content">{product.short_description}</span>
            </Row> */}
            <Row
              align="top"
              justify="center"
              className="product-detail-content-wrapper">
              <Col
                lg={12}
                md={24}
                sm={24}
                xs={24}
                className="content-item-wrap left">
                <ProductOverview product={product} />
              </Col>
              <Col
                lg={12}
                md={24}
                sm={24}
                xs={24}
                className="content-item-wrap right">
                <ProductInformation
                  {...props}
                  productFoam={_productFoam}
                  productSpecCode={_productSpecCode}
                  productCode={productCode}
                  product={product}
                  setProductCode={setProductCode}
                  banners={banners}
                  setBanners={setBanners}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            <BoughtTogetherProducts
              {...props}
              size={size}
              productId={_productId}
              productPath={_path}
              productCode={productCode}
            />
            <RelatedProducts
              {...props}
              size={size}
              productId={_productId}
              productPath={_path}
            />
          </Col>
        </Row>
      </div>
    )
  );
});

export default Product;
